const _registeredCallbacks = {}

export function registerOutsideClick(id, callback) {
  if (!_registeredCallbacks[id]) {
    _registeredCallbacks[id] = callback
  }
}

export function disposeOutsideClick(id) {
  if (_registeredCallbacks[id]) {
    delete _registeredCallbacks[id]
  }
}

export function onOutsideClick(clickEvent) {
  for (const id of Object.keys(_registeredCallbacks)) {
    _registeredCallbacks[id](clickEvent)
  }
}
